import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/admin/complaints")({
  head: () => ({
    meta: [
      { title: "Complaints · Landoo Admin" },
      { name: "description", content: "Complaints — Landoo admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Complaints" role="Admin" items={ADMIN_NAV}>
      <PlaceholderCard
        title="Complaints"
        description="Admin queue for Complaints. Actions and filters will be added here."
      />
    </DashboardShell>
  ),
});
